<template>
  <v-card class="office-info-card pa-3" flat>
    <div class="text-h5 text-center">
      Oficiu Bancassurance
    </div>
    <div class="d-flex align-center">
      <div class="mr-5">
        <v-icon size="32">
          mdi-map-marker
        </v-icon>
      </div>
      <div>
        <div class="font-weight-bold py-4 px-6" style="font-size: 18px;">
          mun. Chisinau, str. Alexandru cel Bun 95
        </div>
      </div>
    </div>
    <div class="d-flex align-center">
      <div class="mr-5">
        <v-icon size="32">
          mdi-clock-time-seven
        </v-icon>
      </div>
      <div style="width: 100%">
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <div>
                  <div v-if="!open" class="d-flex align-center font-weight-bold" style="font-size: 18px;">
                    <div v-if="!todayInfo.closed">
                      Azi deschis de la {{ todayInfo.openingHour }}:00 la {{ todayInfo.closingHour }}:00
                    </div>
                    <div v-else>
                      Zi libera
                    </div>
                  </div>
                  <div v-else class="font-weight-bold" style="font-size: 18px;">Program</div>
                </div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                v-for="day in openingDays"
                :key="day.dayIndex"
                :class="{'font-weight-bold': day.dayIndex === todayInfo.dayIndex}"
                class="d-flex align-center"
              >
                <div class="day-name-box mr-2">
                  {{ day.text }}
                </div>
                <div v-if="!day.closed">
                  {{ day.openingHour }} - {{ day.closingHour }}
                </div>
                <div v-else>
                  Zi libera
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </v-card>
</template>

<script>
import { openingDays } from '@/_utils/static-data';
export default {
  name: 'CompanyInfoCard',
  computed: {
    openingDays() {
      return openingDays;
    },
    todayInfo() {
      const todayIndex = new Date().getDay();
      return this.openingDays.find(el => el.dayIndex === todayIndex);
    }
  }
};
</script>

<style scoped>
.office-info-card {
  width: 535px;
}
.office-info-card button {
  color: rgba(0,0,0,.87);
}
.office-info-card button:hover {
  border-color: transparent;
  background: transparent;
  color: rgba(0,0,0,.87);
}
.day-name-box {
  width: 75px;
}
@media screen and (max-width: 600px) {
  .office-info-card {
    width: 100%;
  }
}
</style>